// Globals
import { FC } from 'react';

// Components
import { FormItem, IFormItemProps } from '@/components';
import { Switch } from '@/ui';
import { StyledTitle, StyledTitleWrapper } from './FormSectionHeaderStyles';

type TFormSectionHeaderProps = {
  fieldName: IFormItemProps['name'];
  rules: IFormItemProps['rules'];
  title: string;
  onToggle?: () => void;
};

const FormSectionHeader: FC<TFormSectionHeaderProps> = ({ fieldName, rules, title, onToggle }) => {
  return (
    <StyledTitleWrapper>
      <StyledTitle>{title}</StyledTitle>
      <FormItem rules={rules} name={fieldName}>
        <Switch onChange={onToggle} />
      </FormItem>
    </StyledTitleWrapper>
  );
};

export default FormSectionHeader;
